import c from "../common";

export default {
  earnLocation: "消費地點",
  earnMethod: "賺取途徑",
  pointBelongToVendor: "積分所屬商戶",

  livePurchase: "店內儲分",
  buyVoucher: c.voucher.chn,
  assistant: c.assistant.chn,
  //
  text1: "賺取記錄"
};
